import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { baseUrl, fetchMyUserDetails, imageBaseUrl } from "../../constants/ApiConstants";
import { useSelector } from "react-redux";
import styled from "styled-components";

import toast from "react-hot-toast";
import axiosInstance from "../../utils/axiosInstance";
import { grey10, linearTopGradient } from "../../constants/colors";
import FullPageLoader from "../../components/FullPageLoader";
import { signOut } from "firebase/auth";
import { auth } from "../../config/firebaseConfig";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import PageHeader from "../../components/PageHeader";
import { updateUserData } from "../../store/appSlice";

export default function Profile() {
  pageTitle("My Profile");
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.appSlice.userData?.id);
  const settings = useSelector((state) => state.appSlice.settings);
  const [userDetail, setUserDetail] = useState();
  const navigate = useNavigate();
  const fetchUserDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchMyUserDetails, { user_id: userId })
      .then((res) => {
        setUserDetail(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUserDetail();
  }, []);

  const handleLogoutTap = async () => {
    await signOut(auth);
    localStorage.removeItem("userData");
    updateUserData(null);
    toast.success("Logged out successfully.");
    navigate("/login", {
      replace: true,
    });
  };

  return (
    <>
      {/* <BannerSectionStyle3 bgUrl="/images/appointments/banner_bg.svg" imgUrl="/images/appointments/banner_img.png" title="Don’t Let Your Health Take a Backseat!" subTitle="Fill out the appointment form below to schedule a consultation with one of our healthcare professionals." /> */}
      <Section topMd={40} topLg={80} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading ? (
          <FullPageLoader />
        ) : (
          <div className="content-wrapper px-3">
            {/* <CommonMobileHeader canBack={true} title={"My Profile"} /> */}
            <PageHeader title="My Profile" />
            <div className="row mt-3">
              <div className="col-md-6  px-2">
                <DoctorContainer className="pb-4">
                  <div className="doctor__image mb-2">
                    {userDetail?.profile_image ? <img className="rounded " src={`${imageBaseUrl}${userDetail?.profile_image}`} style={{ objectFit: "cover" }} /> : <img className="rounded bg-grey" src={`/images/icons/ic_profile.png`} style={{ objectFit: "cover" }} />}
                  </div>
                  <div className="doctor__info ml-2">
                    <strong className="doctor__name text-black">{userDetail?.fullname}</strong>
                    <div className="doctor__designation d-flex align-items-center gap-1 mt-1 mb-2 fs-normal text-grey1">{userDetail?.identity}</div>
                    <Link to="/edit-profile" className="editProfile ml-3 py-2 px-3 bg-grey1 text-sprimary rounded-pill mt-2">
                      Edit Profile
                    </Link>
                  </div>
                </DoctorContainer>
              </div>
              <Settings className="col-md-6 g-2">
                <div className="d flex flex-column gap-2 settting__items">
                  {/* <Link to="/saved-doctors" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Saved Doctors</span>
                  </Link> */}
                  <Link to="/user-wallet" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Wallet</span>
                  </Link>
                  {/* <Link to="/withdraw-requests" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Withdraw Requests</span>
                  </Link> */}
                  <Link to="/patient-appointments" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Appointments</span>
                  </Link>
                  <Link to="/manage-patients" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Manage Patients</span>
                  </Link>
                  <Link to="/prescriptions" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Prescriptions</span>
                  </Link>
                  <Link to={`${baseUrl}/termsOfUse`} className="px-2 py-2 text-grey1 bg-gray">
                    <span>Terms of Use</span>
                  </Link>
                  <Link to={`${baseUrl}/privacypolicy`} className="px-2 py-2 text-grey1 bg-gray">
                    <span>Privacy Policy</span>
                  </Link>
                  {/* <Link to="/faq" className="px-2 py-2 text-grey1 bg-gray">
                    <span>Help & FAQ</span>
                  </Link> */}
                  <button type="button" className="px-2 py-2  bg-gray logout" onClick={handleLogoutTap}>
                    <span>Logout</span>
                  </button>
                  <button type="button" className="px-2 py-2  bg-gray deleteAccount">
                    <span>Delete My Account</span>
                  </button>
                </div>
              </Settings>
            </div>
          </div>
        )}
      </Section>
    </>
  );
}

const DoctorContainer = styled.div`
  display: flex;
  padding-bottom: 0.75rem;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 1rem;
  gap: 1rem;

  .btn-gradient {
    position: fixed;
    left: 0;
    right: 0;
    padding: 12px 16px 16px 12px;
    bottom: 0;
    color: #fff;
    outline: none;
    border: none;
    background: ${linearTopGradient};
    z-index: 5;
  }

  b span {
    color: gray;
    font-size: 0.9rem;
  }
  .doctor__designation img {
    height: 12px;
  }

  .doctor__image img {
    height: 60px;
    width: 60px;
    object-fit: contain;
  }

  .doctor__image {
    width: max-content;
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;
    .doctor__designation {
      display: block !important;
    }
    .doctor__name {
      font-size: 3rem;
      margin-top: 2rem;
      text-align: center;
    }
    .doctor__image img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .doctor__image {
      height: 450px;
    }
    .doctor__info {
      margin: 0 auto;
      width: 100%;
      margin-top: 2rem;
      text-align: center;
    }
  }
  .editProfile {
    font-size: 0.8rem !important;
  }
`;

const Settings = styled.div`
  .settting__items {
    display: flex;
    flex-direction: column;
    a {
      background-color: ${grey10};
      margin-bottom: 3px;
      width: 100%;
      border-radius: 8px;
      font-size: 0.85rem;
    }
  }
  .text-grey {
    color: #929292;
  }
  button {
    outline: none;
    border: none;
  }
  .logout {
    border-radius: 8px;
    background-color: #ffebc7;
    color: #d38900;
    text-align: left;
    font-size: 0.85rem;
  }
  .deleteAccount {
    border-radius: 8px;
    background-color: #ffd8d8;
    color: #e70f00;
    text-align: left;
    font-size: 0.85rem;
  }
`;
